# Three-player god-mode sandbox demo board.
# Load with:  just sandbox scenarios/three_player_demo.scenario
#
# Format (see engine/scenario.spell):
#   SEED <n>
#   PLAYER <id> <life> <name...>      (listing order = seat / turn order)
#   ACTIVE <id>                        (optional; defaults to first PLAYER)
#   <pid> <zone> <card name> [| flags] (zone: hand|battlefield|library|
#                                        graveyard|exile|command)
#   <pid> pool <mana>                  (floating mana, e.g. {R}{G})
#   flags: tapped commander summoning_sick counters=<n> minus=<n> damage=<n>
#          loyalty=<n> lore=<n> copies=<n> as=<label> (sandbox: @label for an oid)

SEED 7
PLAYER p1 20 Alice
PLAYER p2 20 Bob
PLAYER p3 20 Carol
ACTIVE p1

# Alice: a tapped mana elf, a Bolt in hand, two Mountains on top of library.
p1 battlefield Llanowar Elves | tapped
p1 hand Lightning Bolt
p1 library Mountain
p1 library Mountain

# Bob: a vanilla bear.
p2 battlefield Grizzly Bears

# Carol: a Serra Angel that's already taken 2 damage.
p3 battlefield Serra Angel | damage=2
